import { useFormContext } from 'react-hook-form';
import React from 'react';
import { nhomColumns, regionSearchColumns, supplierGroupSearchColumns, supplierSearchColumns } from '@/constants';
import { SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

const DetailTab: React.FC = () => {
  const { setValue } = useFormContext();

  return (
    <div className='w-[800px] min-w-[800px] space-y-4 p-4'>
      <div className='flex flex-col space-y-3'>
        {/* Mã nhà cung cấp */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã nhà cung cấp</Label>
          <SearchField
            type='text'
            searchEndpoint={`/${QUERY_KEYS.NHA_CUNG_CAP}/`}
            searchColumns={supplierSearchColumns}
            dialogTitle='Danh mục nhà cung cấp'
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            onValueChange={value => {
              setValue('ma_ncc', value);
            }}
            className='w-full'
            classNameRelatedField='w-auto min-w-[300px] max-w-full'
          />
        </div>
        {/* Tính số dư */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tính số dư</Label>
          <div className='w-64'>
            <FormField
              name='sap_xep_theo'
              type='select'
              options={[
                { value: 'ma_ncc', label: 'Có' },
                { value: 'ten_ncc', label: 'Không' }
              ]}
              className='w-full'
            />
          </div>
        </div>
        {/* Nhóm NCC */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Nhóm NCC</Label>
          <div className='flex-1'>
            <div className='grid grid-cols-3'>
              <SearchField
                type='text'
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm nhà cung cấp 1'
                columnDisplay='ma_nhom'
                onValueChange={value => {
                  setValue('nhom_ncc_1', value);
                }}
                className='w-48'
              />
              <SearchField
                type='text'
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm nhà cung cấp 2'
                columnDisplay='ma_nhom'
                onValueChange={value => {
                  setValue('nhom_ncc_2', value);
                }}
                className='w-48'
              />
              <SearchField
                type='text'
                searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
                searchColumns={nhomColumns}
                dialogTitle='Danh mục nhóm nhà cung cấp 3'
                columnDisplay='ma_nhom'
                onValueChange={value => {
                  setValue('nhom_ncc_3', value);
                }}
                className='w-48'
              />
            </div>
          </div>
        </div>

        {/* Khu vực */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Khu vực</Label>
          <SearchField
            type='text'
            searchEndpoint={`/${QUERY_KEYS.KHU_VUC}/`}
            searchColumns={regionSearchColumns}
            dialogTitle='Danh mục khu vực'
            columnDisplay='rg_code'
            displayRelatedField='rgname'
            onValueChange={value => {
              setValue('khu_vuc', value);
            }}
            className='w-full'
            classNameRelatedField='w-auto min-w-[300px] max-w-full'
          />
        </div>

        {/* Người lập */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Người lập</Label>
          <div className='w-64'>
            <FormField name='sap_xep_theo' type='text' className='w-full' />
          </div>
        </div>
        {/* Sắp xếp theo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Sắp xếp theo</Label>
          <div className='w-64'>
            <FormField
              name='sap_xep_theo'
              type='select'
              options={[
                { value: 'ma_ncc', label: 'Mã nhà cung cấp' },
                { value: 'ten_ncc', label: 'Tên nhà cung cấp' },
                { value: 'so_du', label: 'Số dư' }
              ]}
              className='w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailTab;
